export default function objectToURLSearchParams(
    obj: Record<string, any>
): URLSearchParams {
    const params = new URLSearchParams()

    for (const key in obj) {
        if (Array.isArray(obj[key])) {
            obj[key].forEach((value: any) => {
                params.append(`${key}[]`, value)
            })
        } else {
            params.append(key, obj[key])
        }
    }

    return params
}
